import type {
  GenerateOtpRequest,
  GenerateOtpResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
  VerifyEmailRequest,
  VerifyEmailResponse,
  RegisterRequest,
  RegisterResponse,
  LoginRequest,
  LoginResponse,
} from './utils/types';
import { client } from '../common/client';

class AuthAPIClient {
  public async generateOtp(payload: GenerateOtpRequest): Promise<GenerateOtpResponse> {
    const response = await client.post('/otp/generate', payload).then((res) => res.data);
    return response;
  }

  public async verifyOtp(payload: VerifyOtpRequest): Promise<VerifyOtpResponse> {
    const response = await client.post('/otp/verify', payload).then((res) => res.data);
    return response;
  }

  public async verifyEmail(payload: VerifyEmailRequest): Promise<VerifyEmailResponse> {
    const response = await client.post('/otp/verifyEmail', payload).then((res) => res.data);
    return response;
  }

  public async register(payload: RegisterRequest): Promise<RegisterResponse> {
    const response = await client.post('/auth/register', payload).then((res) => res.data);
    return response;
  }

  public async login(payload: LoginRequest): Promise<LoginResponse> {
    const response = await client.post('/auth/login', payload).then((res) => res.data);
    return response;
  }
}

export const authAPIClient = new AuthAPIClient();
